"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookie = exports.setCookie = exports.getCookie = exports.getUrlArgs = exports.parseUrlArgs = exports.changeUrl = exports.redirect = void 0;
function redirect(url) { window.location.href = url; }
exports.redirect = redirect;
;
function changeUrl(url, state = {}, title = '') { window.history.replaceState(state, title, url); }
exports.changeUrl = changeUrl;
;
function parseUrlArgs(urlString) {
    const url = new URL(urlString);
    const args = {};
    url.pathname.split('/').filter(Boolean).forEach((component, index) => {
        args[`path${index}`] = decodeURIComponent(component);
    });
    url.searchParams.forEach((value, key) => { args[key] = value; });
    return args;
}
exports.parseUrlArgs = parseUrlArgs;
function getUrlArgs() { return parseUrlArgs(window.location.href); }
exports.getUrlArgs = getUrlArgs;
function getCookie(name) {
    const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
exports.getCookie = getCookie;
function setCookie(name, value, options = {}) {
    let cacheOptions = Object.assign({ path: '/' }, options);
    if (cacheOptions.expires instanceof Date) {
        cacheOptions.expires = cacheOptions.expires.toUTCString();
    }
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (let optionKey in cacheOptions) {
        updatedCookie += "; " + optionKey;
        let optionValue = cacheOptions[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }
    document.cookie = updatedCookie;
}
exports.setCookie = setCookie;
function deleteCookie(name) {
    this.setCookie(name, "", { 'max-age': -1 });
}
exports.deleteCookie = deleteCookie;
//# sourceMappingURL=web.js.map